<template>
    <q-page padding>
        <!-- Modern Table Card -->
        <q-card class="autoagendamiento-table-card">
            <q-table
                ref="tableRef"
                :rows="rows"
                :columns="columns"
                row-key="name"
                :loading="loading"
                :rows-per-page-options="[20, 50]"
                :filterMethod="filterMethod"
                :filter="filterTerms"
                class="modern-autoagendamiento-table sticky-header-table"
                dense
                flat
            >
                <template v-slot:top-left>
                    <div class="page-title">
                        <q-icon name="event_available" class="q-mr-md" size="lg" />
                        <div>
                            <div class="text-h6">Auto Agendamiento</div>
                            <div class="text-caption text-grey-7">Gestión de agendamiento de camiones</div>
                        </div>
                    </div>
                </template>
                <template v-slot:top-right>
                    <div class="filters-section">
                        <q-input
                            v-model="globalFilter"
                            placeholder="Buscar en tabla..."
                            class="search-input"
                            outlined
                            dense
                            debounce="300"
                        >
                            <template v-slot:prepend>
                                <q-icon name="search" />
                            </template>
                            <template v-slot:append>
                                <q-icon
                                    v-if="globalFilter"
                                    name="close"
                                    @click="globalFilter = ''"
                                    class="cursor-pointer"
                                />
                            </template>
                        </q-input>
                    </div>
                </template>

                <template v-slot:top-row="{ cols }">
                <tr>
                    <q-td v-for="col in cols" :key="col.name">
                        <q-select
                            v-if="col.options"
                            outlined
                            dense
                            v-model.trim="filter[col.name]"
                            @click.stop
                            clearable
                            :options="col.options()"
                        />
                        <q-input
                            v-else
                            outlined
                            dense
                            v-model.trim="filter[col.name]"
                            @click.stop
                            clearable
                        />
                    </q-td>
                </tr>
            </template>
            <template v-slot:body-cell-email="props">
                <q-td :props="props">
                    <span class="cursor-pointer">{{ props.value }}</span>

                    <q-popup-edit
                        v-model="props.row.email"
                        buttons
                        v-slot="scope"
                        label-set="Guardar"
                        label-cancel="Cancelar"
                        @save="
                            clienteUpdate(props.row.IDCLI, { A1_EMAIL: $event })
                        "
                    >
                        <q-input
                            v-model="scope.value"
                            dense
                            autofocus
                            counter
                            @keyup.enter="scope.set"
                        />
                    </q-popup-edit>
                </q-td>
            </template>
            <template v-slot:body-cell-telefono="props">
                <q-td :props="props">
                    <span class="cursor-pointer"
                        >{{ props.value }}
                        <q-btn
                            v-if="!props.value?.trim()"
                            flat
                            size="xs"
                            round
                            icon="mdi-phone-plus"
                            color="blue"
                        />
                        <q-popup-edit
                            v-model="props.row.A1_TEL"
                            buttons
                            v-slot="scope"
                            label-set="Guardar"
                            label-cancel="Cancelar"
                            @save="
                                clienteUpdate(props.row.IDCLI, {
                                    A1_TEL: $event,
                                })
                            "
                        >
                            <q-input
                                v-model="scope.value"
                                dense
                                autofocus
                                counter
                                @keyup.enter="scope.set"
                            />
                        </q-popup-edit>
                    </span>
                    <q-btn
                        v-if="
                            props.row.A1_TEL?.trim().length > 0 &&
                            props.row.camionescant > 0
                        "
                        flat
                        size="sm"
                        round
                        icon="mdi-whatsapp"
                        color="green-5"
                        @click="share(props.row)"
                    />
                </q-td>
            </template>
            <template v-slot:body-cell-uid="props">
                <q-td :props="props">
                    <q-btn
                        v-if="props.row.camionescant > 0"
                        flat
                        size="sm"
                        round
                        icon="mdi-link"
                        color="primary"
                        @click="oppenLink(props.row)"
                    />
                </q-td>
            </template>
            <template v-slot:body-cell-camionescant="props">
                <q-td :props="props" class="text-right">
                    <span class="cursor-pointer">{{ props.value }}</span>
                    <q-btn
                        @click="camionDataEdit(props.row)"
                        flat
                        size="xs"
                        round
                        icon="mdi-pencil"
                        color="blue"
                    />
                </q-td>
            </template>
        </q-table>
        <CamionDialog
            v-model="camionDialog"
            v-model:cantidad="cantidad"
            v-model:tipo="tipo"
            v-model:carroceria="carroceria"
            v-model:observaciones="observaciones"
            v-model:empresa="empresa"
            v-model:cliente="cliente"
            v-model:pedido="pedido"
            v-model:fecha="fecha"
            v-model:deposito="deposito"
            v-model:row="rowData"
            v-model:fecha-disponibilidad="fechaDisponibilidad"
            :loading="loading"
            :id="idSc5"
            @data-update="onDataUpdate"
        />
        </q-card>
    </q-page>
</template>
<script setup>
import { useForm } from "@inertiajs/vue3";
import CamionDialog from "@/pages/AutoAgendamiento/CamionDialog.vue";
import { ref,  computed, reactive } from "vue";
import { useQuasar } from "quasar";
import { useClipboard } from "@vueuse/core";
import { format, parse } from "date-fns";
import { uniqBy } from "lodash";

const { rows } = defineProps({ rows: Array });
const { copy } = useClipboard();
const $q = useQuasar();
const filter = reactive({});
const globalFilter = ref("");
const filterTerms = computed(() => {
    return getFilterTerms(filter);
});
const tableRef = ref();
const loading = ref(false);

const columns = [
    {
        name: "C6_FILIAL",
        label: "Empresa",
        field: "C6_FILIAL",
        align: "left",
        sortable: true,
        options: () => empresas.value,
    },
    {
        name: "PLANTA",
        label: "Planta",
        field: "PLANTA",
        align: "left",
        sortable: true,
        options: () => plantas.value,
    },
    {
        name: "SIT_CRED",
        label: "Estado",
        field: "SIT_CRED",
        align: "left",
        sortable: true,
        options: () => estados.value,
    },
    {
        name: "SIT_LOG",
        label: "Estado Stock",
        field: "SIT_LOG",
        align: "left",
        sortable: true,
        options: () => stock.value,
    },
    {
        name: "DEPO_ENT",
        label: "Depósito",
        field: "DEPO_ENT",
        align: "left",
        sortable: true,
        options: () => depositos.value,
    },
    {
        name: "C6_NUM",
        label: "Pedido",
        field: "C6_NUM",
        align: "left",
        sortable: true,
    },
    {
        name: "C6_USREQVE",
        label: "Presupuesto",
        field: "C6_USREQVE",
        align: "left",
        sortable: true,
    },
    {
        name: "A1_NOME",
        label: "Cliente",
        field: "A1_NOME",
        align: "left",
        sortable: true,
    },
    {
        name: "A3_NOME",
        label: "Vendedor",
        field: "A3_NOME",
        align: "left",
        sortable: true,
    },
    {
        name: "telefono",
        label: "Telefono",
        field: "A1_TEL",
        align: "left",
        sortable: true,
    },
    {
        name: "email",
        label: "Email",
        field: "email",
        align: "left",
        sortable: true,
    },
    {
        name: "C5_CLIENTE",
        label: "Entrega",
        field: "C6_ENTREG",
        align: "left",
        format: (val) =>
            format(parse(val, "yyyyMMdd", new Date()), "dd/MM/yyyy"),
        sortable: true,
    },
    {
        name: "camionescant",
        label: "Cant Camiones",
        field: "camionescant",
        align: "left",
        sortable: true,
    },
    {
        name: "camionestipo",
        label: "Tipo Camiones",
        field: "camionestipo",
        align: "left",
        sortable: true,
    },
    {
        name: "carroceria",
        label: "Carrocería",
        field: "carroceria",
        align: "left",
        sortable: true,
    },
    {
        name: "fecha_disponibilidad",
        label: "Fecha Disponibilidad",
        format: (val) =>
            val && format(parse(val, "yyyyMMdd", new Date()), "dd/MM/yyyy"),
        field: "fecha_disponibilidad",
        align: "left",
        sortable: true,
    },
    {
        name: "observaciones",
        label: "Observaciones",
        field: "observaciones",
        align: "left",
        sortable: true,
    },
    {
        name: "uid",
        label: "Link",
        field: "uid",
        align: "left",
        sortable: true,
    },
    {
        name: "acciones",
        required: true,
        label: "Acciones",
        align: "center",
        sortable: false,
    },
];

const plantas = computed(() => {
    return uniqBy(rows, "PLANTA")
        .map((row) => row.PLANTA)
        .sort();
});
const empresas = computed(() => {
    return uniqBy(rows, "C6_FILIAL")
        .map((row) => row.C6_FILIAL)
        .sort();
});
const depositos = computed(() => {
    return uniqBy(rows, "DEPO_ENT")
        .map((row) => row.DEPO_ENT)
        .sort();
});
const estados = computed(() => {
    return uniqBy(rows, "SIT_CRED")
        .map((row) => row.SIT_CRED)
        .sort();
});
const stock = computed(() => {
    return uniqBy(rows, "SIT_LOG")
        .map((row) => row.SIT_LOG)
        .sort();
});

const getFilterTerms = (filter) => {
    return Object.entries(filter).map((entry) => {
        return { column: entry[0], value: entry[1] };
    });
};

const filterMethod = (rows, terms) => {
    function todasPropiedadesVacias(obj) {
        return !(
            obj.value !== null &&
            obj.value !== undefined &&
            obj.value !== ""
        );
    }

    // Aplicar filtros por columna primero
    if (!terms.every(todasPropiedadesVacias)) {
        for (const term of terms) {
            if (
                term.value === null ||
                term.value === undefined ||
                term.value === ""
            ) {
                continue;
            }
            rows = rows.filter((row) => {
                return ("" + row[term.column])
                    .toLocaleLowerCase()
                    .includes(("" + term.value).toLocaleLowerCase());
            });
        }
    }

    // Aplicar búsqueda global después
    if (globalFilter.value && globalFilter.value.trim() !== "") {
        const searchTerm = globalFilter.value.toLocaleLowerCase();
        rows = rows.filter((row) => {
            return columns.some((col) => {
                const value = row[col.field];
                if (value === null || value === undefined) return false;
                return ("" + value).toLocaleLowerCase().includes(searchTerm);
            });
        });
    }

    return rows;
};

const share = ({
    C6_NUM,
    PLANTA,
    NNR_XUBIC,
    A1_NOME,
    camionescant,
    camionestipo,
    carroceria,
    observaciones,
    C6_USREQVE,
    A1_TEL,
    uid,
    fecha_disponibilidad,
}) => {
    const fechaDisponibilidadParsed =
        fecha_disponibilidad &&
        format(
            parse(fecha_disponibilidad, "yyyyMMdd", new Date()),
            "dd-MM-yyyy"
        );
    const link = `https://web3.gltn.com.ar/#/form/${uid}`;
    const info = `
📢*GRUPO LTN - AVISO IMPORTANTE*

Estimado/a, su presupuesto ${C6_USREQVE.trim()} (PV ${C6_NUM.trim()}) de ${A1_NOME.trim()} va a estar listo para
retiro a partir de *${fechaDisponibilidadParsed}* en *${PLANTA.trim()}*. Se requiere ${camionescant} camión/es de tipo ${camionestipo} ${carroceria}.
📍 Ubicación: ${NNR_XUBIC.trim()}

Observaciones:
${observaciones}

🔹 Requisitos:
✔ Al retirar, deberá traer 10 fajas de sujeción finas de tipo traca manual o 1 faja cada 2 mts lineales de panel.
✔ Quien retire debe llevar chaleco refractario, casco y calzado de seguridad.
✔ Debe avisar con al menos 24 horas de antelación para coordinar el retiro.

⚠ Desde la notificación de disponibilidad, hay un plazo máximo de 7 días para realizar el retiro. Pasado este período, se podrá aplicar un costo adicional por almacenamiento.

📅 Para agendar haga clic aqui: ${link}`;

    const msj = `https://wa.me/${A1_TEL.trim()}`;
    copy(info);
    window.open(msj, "_blank");
};

const clienteUpdate = (id, value) => {
    const form = useForm({
         ...value ,
    });
    form.put(route('clientes.update', id),{
        onStart: () => {
            loading.value = true;
        },
        onFinish: () => {
            loading.value = false;
        },
        onSuccess: () => {
            $q.notify({
                type: "positive",
                message: "Cliente actualizado correctamente",
            });
        },
        onError: (error) => {
            $q.notify({
                type: "negative",
                message: error.response.data.message,
            });
        },
    })
};
const camionDialog = ref(false);
const cantidad = ref(0);
const tipo = ref("");
const carroceria = ref("");
const observaciones = ref("");
const empresa = ref("");
const pedido = ref("");
const fecha = ref("");
const fechaDisponibilidad = ref("");
const cliente = ref("");
const deposito = ref("");
const rowData = ref({});
const camionDataEdit = (row) => {
    const fechaDisponibilidadParsed =
        row.fecha_disponibilidad &&
        format(
            parse(row.fecha_disponibilidad, "yyyyMMdd", new Date()),
            "dd-MM-yyyy"
        );
    cantidad.value = row.camionescant;
    tipo.value = row.camionestipo;
    carroceria.value = row.carroceria;
    observaciones.value = row.observaciones;
    fechaDisponibilidad.value = fechaDisponibilidadParsed;
    empresa.value = row.C6_FILIAL;
    pedido.value = row.C6_NUM;
    fecha.value = row.C6_ENTREG;
    cliente.value = row.C5_CLIENTE;
    deposito.value = row.DEPO_ENT;
    rowData.value = row;
    camionDialog.value = true;
};
const onDataUpdate = () => {
    tableRef.value.requestServerInteraction();
};

const oppenLink = (row) => {
    const routeData = route('form', [row.uid]);
    window.open(routeData);
};
</script>

<style lang="scss" scoped>
@use 'sass:color';

// Modern Table Card
.autoagendamiento-table-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .modern-autoagendamiento-table {
        :deep(.q-table__top) {
            padding: 16px;
            background: linear-gradient(to right, #f5f5f5, #fafafa);
            border-bottom: 2px solid #e0e0e0;
        }

        :deep(.q-table thead th) {
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            background: #fafafa;
            color: #424242;
        }

        :deep(.q-table tbody tr) {
            transition: all 0.2s ease;

            &:hover {
                background: #f5f9ff;
                transform: translateX(2px);
            }
        }

        :deep(.q-table tbody td) {
            border-bottom: 1px solid #f0f0f0;
        }
    }
}

// Page Title
.page-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

// Filters Section
.filters-section {
    display: flex;
    align-items: center;
    gap: 12px;

    .search-input {
        min-width: 300px;
    }
}

// Action Buttons
.action-buttons {
    display: flex;
    gap: 4px;
    justify-content: center;

    .action-btn {
        transition: all 0.2s ease;

        &:hover {
            transform: scale(1.1);
        }
    }
}

// Responsive
@media (max-width: 1024px) {
    .filters-section {
        .search-input {
            min-width: 200px;
        }
    }
}
</style>
